import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Heart, MessageCircle, User, Bell, Check } from 'lucide-react';
import { useState } from 'react';

const initialNotifications = [
  { id: 1, type: 'like', user: '旅行者小王', content: '赞了你的游记《大理慢时光》', time: '2分钟前', read: false },
  { id: 2, type: 'comment', user: '摄影师李', content: '评论了你的日记：拍得真棒！', time: '1小时前', read: false },
  { id: 3, type: 'follow', user: '背包客阿杰', content: '关注了你', time: '3小时前', read: true },
  { id: 4, type: 'system', content: '欢迎加入西蒙的猫旅行日记，开始你的旅程吧', time: '昨天', read: true },
];

const iconMap = {
  like: { icon: Heart, bg: 'bg-danger/10', color: 'text-danger' },
  comment: { icon: MessageCircle, bg: 'bg-primary/10', color: 'text-primary' },
  follow: { icon: User, bg: 'bg-success/10', color: 'text-success' },
  system: { icon: Bell, bg: 'bg-accent/20', color: 'text-secondary' },
};

const Notifications = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('全部');
  const [list, setList] = useState(initialNotifications);

  const filtered = activeTab === '全部' ? list : list.filter((n) => {
    const map = { '点赞': 'like', '评论': 'comment', '关注': 'follow', '系统': 'system' };
    return n.type === map[activeTab];
  });

  const markAllRead = () => setList(list.map((n) => ({ ...n, read: true })));

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-text-primary">通知</h1>
          <Button variant="ghost" onClick={markAllRead} className="text-sm text-primary hover:text-primary-hover">
            <Check className="w-4 h-4 mr-1" /> 全部已读
          </Button>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mb-6">
          <TabsList className="bg-white rounded-btn p-1 shadow-card">
            {['全部', '点赞', '评论', '关注', '系统'].map((t) => (
              <TabsTrigger key={t} value={t} className="rounded-btn px-4 data-[state=active]:bg-primary data-[state=active]:text-white text-xs">
                {t}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        <div className="space-y-3">
          {filtered.length === 0 ? (
            <div className="text-center py-20">
              <Bell className="w-16 h-16 text-text-tertiary opacity-40 mx-auto mb-4" />
              <p className="text-text-secondary">暂无通知</p>
            </div>
          ) : (
            filtered.map((n) => {
              const meta = iconMap[n.type];
              const Icon = meta.icon;
              return (
                <Card
                  key={n.id}
                  className={`border-0 shadow-card rounded-card bg-white cursor-pointer transition-opacity ${n.read ? 'opacity-60' : ''}`}
                  onClick={() => navigate('/travelogues')}
                >
                  <CardContent className="p-4 flex items-start gap-3">
                    {!n.read && <div className="w-2 h-2 rounded-full bg-primary mt-2 shrink-0" />}
                    {n.read && <div className="w-2 h-2 shrink-0" />}
                    <div className={`w-10 h-10 rounded-full ${meta.bg} flex items-center justify-center shrink-0`}>
                      <Icon className={`w-5 h-5 ${meta.color}`} />
                    </div>
                    <div className="flex-1">
                      <p className="text-sm text-text-primary">
                        {n.user && <span className="font-medium">{n.user}</span>} {n.content}
                      </p>
                      <p className="text-xs text-text-tertiary mt-1">{n.time}</p>
                    </div>
                  </CardContent>
                </Card>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
